import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps } from '~commonInfra/utils/ConnectUtils';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { ConnectedSpaceInfoProvider } from '~src/spacesPlatform/components/Explorer/helpers/SpaceInfoProvider';
import { ServerSettingsSubspaceName, SpaceInfo, SpaceItemForNonEntitySpace } from '~src/spacesPlatform/state/SpaceInfo';

import { ConnectedServerSettingsSpace } from './ServerSettingsSpace';

export interface ServerSettingsProviderDispatchProps {
  readonly enterSpace: (spaceInfo: SpaceInfo) => void;
  readonly requestSpaceContents: () => void;
}

export interface ServerSettingsSpaceProviderOwnProps {
  readonly subspaceName: ServerSettingsSubspaceName;
}

export type ServerSettingsSpaceProviderProps = ServerSettingsSpaceProviderOwnProps & ServerSettingsProviderDispatchProps;

export function ServerSettingsSpaceProvider(props: ServerSettingsSpaceProviderProps) {

  React.useEffect(() => {
    const enterSpace = props.enterSpace;
    const requestSpaceContents = props.requestSpaceContents;
    const subspaceName = props.subspaceName;
    enterSpace({spaceType: 'serversettings', subspaceName, item: SpaceItemForNonEntitySpace});
    requestSpaceContents();
  }, [props.enterSpace, props.requestSpaceContents, props.subspaceName]);

  const spaceInfo: SpaceInfo = {
    spaceType: 'serversettings',
    subspaceName: props.subspaceName,
    item: SpaceItemForNonEntitySpace
  };

  return (
    <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
      <ConnectedServerSettingsSpace {...props} server={getSessionManagementServiceInstance()}/>
    </ConnectedSpaceInfoProvider>
  );
}

const mapDispatchToProps: MapDispatchToProps<ServerSettingsProviderDispatchProps> = (dispatch) => bindActionCreators({
  enterSpace,
  requestSpaceContents,
}, dispatch);

export const ConnectedServerSettingsSpaceProvider: React.ComponentClass<ServerSettingsSpaceProviderOwnProps>
  = connect(null, mapDispatchToProps)(ServerSettingsSpaceProvider);
